var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var FileEmpty = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 832 1024", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M736 1024H96a96.11 96.11 0 0 1-96-96V96A96.11 96.11 0 0 1 96 0h384a64.07 64.07 0 0 1 64 64v192a32 32 0 0 0 32 32h146.75L585.37 150.63a32 32 0 0 1 45.26-45.26l192 192A32 32 0 0 1 800 352H576a96.11 96.11 0 0 1-96-96V64H96a32 32 0 0 0-32 32v832a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32V416a32 32 0 0 1 64 0v512a96.11 96.11 0 0 1-96 96z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default FileEmpty;
//# sourceMappingURL=FileEmpty.js.map